import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

const useTeacherSubjectGet = (teacherId) => {
  const requestUrl = `${MONOLITH_ORIGIN}/api/v2/teacher-subjects/${teacherId}/`;
  return useRestQuery(requestUrl, { skip: !teacherId });
};

export default useTeacherSubjectGet;
